import { Box, useColorMode } from '@chakra-ui/react';
import { FC, useMemo } from 'react';
import { useDevice } from '../../../../hooks/useDevice';

export const WaitingAnswerTag: FC = () => {
  const { colorMode } = useColorMode();
  const device = useDevice();

  const darkMode = useMemo(() => colorMode === 'dark', [colorMode]);
  const bgColor = useMemo(() => (darkMode ? '#1E2025' : '#EDEDF4'), [darkMode]);
  const color = useMemo(() => (darkMode ? '#C5C6CF' : '#45474E'), [darkMode]);
  const borderColor = useMemo(() => (darkMode ? '#AFC7FB29' : '#2E74DC29'), [darkMode]);

  return (
    <Box
      display="inline"
      fontSize={device === 'mobile' ? 'xx-small' : 'xs'}
      color={color}
      bg={bgColor}
      borderColor={borderColor}
      px={2}
      borderRadius={10}
      border="1px solid"
    >
      Aguardando monitor
    </Box>
  );
};
